import { render } from "./AppVue.vue?vue&type=template&id=1bcf12d5&scoped=true"
import script from "./AppVue.vue?vue&type=script&lang=js"
export * from "./AppVue.vue?vue&type=script&lang=js"

import "./AppVue.vue?vue&type=style&index=0&id=1bcf12d5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcf12d5"]])

export default __exports__